import React from 'react';
import Component from '@vfuk/core-divider';
const CoreDivider = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CoreDivider;
